export default "__VITE_ASSET__aa79c199__"